import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { IoMdArrowDropdown, IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import classes from "./Header.module.scss";
function Header() {
  const [click, setClick] = useState(false);
  const menuClick = () => {
    setClick(!click);
  };

  return (
    <div className={classes.header}>
      <div className={click ? classes.headerLeftCenter : classes.headerLeft}>
        <p>
          <Link to='/'>Money Magic</Link>
        </p>
      </div>
      <div className={click ? classes.headerRightNone : classes.headerRight}>
        <div>
          <Link to='/blogs'>Blogs</Link>
        </div>
        <div>
          <Link to='/calculators'>Calculators</Link>
        </div>
        <div>
          <Link to='/news'>News</Link>
        </div>
        <div className={classes.headerDropdownModules}>
          <Link to='/modules'>Modules</Link>
          <IoMdArrowDropdown />
          <div className={classes.headerDropdownModulesContent}>
            <Link to='/mutualFundsModules'>Mutual Funds Modules</Link>
            <Link to='/stockMarketModules'>Stock Market Modules</Link>
          </div>
        </div>

        <div className={classes.headerDropdownStockTools}>
          <Link to='#stockTools'>Stock Tools</Link>
          <IoMdArrowDropdown />
          <div className={classes.headerDropdownStockToolsContent}>
            <Link to='/stockAnalysis'>Stock Analysis</Link>
            <Link to='/stockComparisons'>Stock Comparisons</Link>
            <Link to='/stockReview'>Stock Review</Link>
          </div>
        </div>
        <div>
          <Link to='/profile'>Profile</Link>
        </div>
      </div>
      <span
        className={click ? classes.headerFiMenuClose : classes.headerFiMenu}
        onClick={menuClick}
      >
        <FiMenu />
      </span>
      <span
        className={click ? classes.headerFiMenu : classes.headerFiMenuClose}
        onClick={menuClick}
      >
        <IoMdClose />
      </span>
    </div>
  );
}

export default Header;
